<template>
    <PtDialog
        v-if="dialogVisible"
        :visible="true"
        :title="currentTitle"
        width="400px"
        @close="handleCancel"
    >
        <p class="text-gray-450">
            {{ currentMessage }}
        </p>
        <template #footer>
            <button class="th-btn th-btn-secondary" @click="handleCancel">
                {{ currentCancelButtonText }}
            </button>
            <button class="th-btn th-btn-warning" @click="handleConfirm">
                {{ currentConfirmButtonText }}
            </button>
        </template>
    </PtDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PtDialog from '@patsnap-biz/dialog';

interface ConfirmDialogOptions {
    title?: string;
    message?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

const dialogVisible = ref(false);
const currentTitle = ref('');
const currentMessage = ref('');
const currentConfirmButtonText = ref('确认');
const currentCancelButtonText = ref('取消');

let resolvePromise: ((value: boolean) => void) | null = null;

function open(options: ConfirmDialogOptions = {}): Promise<boolean> {
    currentTitle.value = options.title || '';
    currentMessage.value = options.message || '';
    currentConfirmButtonText.value = options.confirmButtonText || '确认';
    currentCancelButtonText.value = options.cancelButtonText || '取消';

    return new Promise((resolve) => {
        resolvePromise = resolve;
        dialogVisible.value = true;
    });
}

function handleConfirm() {
    dialogVisible.value = false;
    resolvePromise?.(true);
    resolvePromise = null;
}

function handleCancel() {
    dialogVisible.value = false;
    resolvePromise?.(false);
    resolvePromise = null;
}

defineExpose({
    open,
});
</script>
